// keep in sync with tailwind.config.js
export const breakpoints = {
  mobile: '500px',
  sm: '800px',
  md: '1024px',
  lg: '1216px',
  xl: '1300px',
  '2xl': '1436px',
}
